<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { RowSlot } from '@shared/ui/other'
import { LinkTextPrimaryMedium } from '@shared/ui/links'

import { useMainInfoAssignLimit } from '../../model/main-info-assign-limit.hook'

defineOptions({
  name: 'MainInfoAssignLimit',
})

const {
  refActiveStudents,
  refLimit,
  refHref,
} = useMainInfoAssignLimit()
</script>

<template>
  <RowSlot
    label="Assigned"
    tooltip="Active students / assign limit"
  >
    <LinkTextPrimaryMedium
      :href="refHref"
      target="_blank"
    >
      {{ refActiveStudents }}
    </LinkTextPrimaryMedium>
    <AppText name="body1-medium">
      &nbsp;/ {{ refLimit }}
    </AppText>
  </RowSlot>
</template>
